declare namespace $ {

	type $mol_paragraph__sub_giper_baza_pawn_dump_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_paragraph['sub'] >
	>
	type $mol_textarea__enabled_giper_baza_pawn_dump_2 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['can_change'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__hint_giper_baza_pawn_dump_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_giper_baza_pawn_dump_4 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['key_new'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__submit_giper_baza_pawn_dump_5 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['add_key'] >
		,
		ReturnType< $mol_textarea['submit'] >
	>
	type $mol_textarea__enabled_giper_baza_pawn_dump_6 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['can_change'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__hint_giper_baza_pawn_dump_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_giper_baza_pawn_dump_8 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['value_new'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__submit_giper_baza_pawn_dump_9 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['add_value'] >
		,
		ReturnType< $mol_textarea['submit'] >
	>
	type $mol_textarea__enabled_giper_baza_pawn_dump_10 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['can_change'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__value_giper_baza_pawn_dump_11 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__enabled_giper_baza_pawn_dump_12 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['can_change'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__value_giper_baza_pawn_dump_13 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['value_str'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_select__value_giper_baza_pawn_dump_14 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['unit_tag'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__enabled_giper_baza_pawn_dump_15 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['can_change'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_select__dictionary_giper_baza_pawn_dump_16 = $mol_type_enforce<
		({ 
			'term': string,
			'solo': string,
			'vals': string,
			'keys': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_view__sub_giper_baza_pawn_dump_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $giper_baza_unit_sand_dump__land_giper_baza_pawn_dump_18 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['land'] >
		,
		ReturnType< $giper_baza_unit_sand_dump['land'] >
	>
	type $giper_baza_unit_sand_dump__sand_giper_baza_pawn_dump_19 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['unit_value'] >
		,
		ReturnType< $giper_baza_unit_sand_dump['sand'] >
	>
	type $giper_baza_unit_sand_dump__enabled_giper_baza_pawn_dump_20 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['can_change'] >
		,
		ReturnType< $giper_baza_unit_sand_dump['enabled'] >
	>
	type $giper_baza_pawn_dump__tag_giper_baza_pawn_dump_21 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['unit_tag'] >
		,
		ReturnType< $giper_baza_pawn_dump['tag'] >
	>
	type $giper_baza_pawn_dump__addons_giper_baza_pawn_dump_22 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['pawn_addons'] >
		,
		ReturnType< $giper_baza_pawn_dump['addons'] >
	>
	type $giper_baza_pawn_dump__pawn_giper_baza_pawn_dump_23 = $mol_type_enforce<
		ReturnType< $giper_baza_pawn_dump['pawn_inner'] >
		,
		ReturnType< $giper_baza_pawn_dump['pawn'] >
	>
	type $mol_view__sub_giper_baza_pawn_dump_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_giper_baza_pawn_dump_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $giper_baza_pawn_dump extends $mol_expander {
		can_change( ): ReturnType< ReturnType< $giper_baza_pawn_dump['pawn'] >['can_change'] >
		land( ): ReturnType< ReturnType< $giper_baza_pawn_dump['pawn'] >['land'] >
		title( ): string
		Head( ): $mol_paragraph
		key_new( next?: string ): string
		add_key( next?: any ): any
		Add_key( ): $mol_textarea
		value_new( next?: string ): string
		add_value( next?: any ): any
		Add_value( ): $mol_textarea
		text( next?: string ): string
		Value_text( ): $mol_textarea
		value_str( next?: string ): string
		Value_str( ): $mol_textarea
		unit_tag( id: any, next?: string ): string
		Unit_tag( id: any): $mol_select
		unit_time( id: any): string
		Unit_time( id: any): $mol_view
		unit_value( id: any): any
		Unit_value( id: any): $giper_baza_unit_sand_dump
		pawn_addons( id: any): readonly(any)[]
		pawn_inner( id: any): $giper_baza_pawn
		Pawn_inner( id: any): $giper_baza_pawn_dump
		Inner( id: any): $mol_view
		pawns( ): readonly(any)[]
		pawn( ): $giper_baza_pawn
		tag( ): string
		label( ): readonly(any)[]
		addons( ): readonly(any)[]
		Tools( ): $mol_view
		editors( ): readonly(any)[]
		content( ): ReturnType< $giper_baza_pawn_dump['pawns'] >
	}
	
}

//# sourceMappingURL=dump.view.tree.d.ts.map